/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'dva';
import { useLocation, history } from 'umi';
import qs from 'qs';
import classnames from 'classnames';
import dayjs from 'dayjs';
import { Box, IconButton, Button, useTheme } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SearchGroup from './components/search_group/SearchGroup';
import TablePage from './components/table_page/TablePage';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import {
  download,
  uploadExcel,
  downLoadPrivateFile,
} from '@/utils/downloadUtil.js';
import Loading from '@/components/loading_ml/Loading';
import ActionBtnGroup from './components/action_group/ActionBtnGroup';
import IndexStyled from './IndexStyled.jsx';

const GoodsManagement = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchRef = useRef();
  const [isSearch, setIsSearch] = useState(false);
  const { query, pathname } = location;
  // 结构到所有查询条件，包括分页条件
  const {
    orderNo,
    status,
    refreshTime,
    exchangeBeginDateTime,
    exchangeEndDateTime,
    giftType,
    pageNum = '1',
    pageSize = '10',
    shelfId,
    mobile,
    giftTitle,
    memberCode,
    masterOrderNo,
  } = query;

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['giftExchangeRecord/getQueryOrderPage'];
  const queryOrderPage = useSelector(
    (state) => state.giftExchangeRecord.queryOrderPage,
  );
  const inputUploadExcelRef = useRef(null);
  // 批量导入dialog状态
  const [batchImportOpen, setBatchImportOpen] = useState(false);
  //批量导入成功失败的状态监听,ready=>打开导入弹框，start=>点击上传文件按钮，success=>成功，fail=>失败，warning=>有成功有失败
  const [importStatus, setImportStatus] = useState('ready');
  //存储上传成功的数据
  const [uploadSuccessData, setUploadSuccessData] = useState(null);
  //监听批量导入的状态
  const [importFetchStatus, setImportFetchStatus] = useState();

  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        refreshTime: time,
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: 1,
      })}`,
    );
  };

  // 获取礼品管理列表
  const fetchData = useCallback(() => {
    const values = {
      orderNo,
      status,
      // giftReceiveMethod,
      refreshTime,
      pageNum,
      pageSize,
      exchangeBeginDateTime: exchangeBeginDateTime
        ? `${exchangeBeginDateTime} 00:00:00`
        : null,
      exchangeEndDateTime: exchangeEndDateTime
        ? `${exchangeEndDateTime} 23:59:59`
        : null,
      giftType,
      shelfId,
      mobile,
      giftTitle,
      memberCode,
      masterOrderNo,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'giftExchangeRecord/getQueryOrderPage',
      payload: {
        values,
      },
    });
  }, [
    dispatch,
    orderNo,
    pageNum,
    pageSize,
    status,
    // giftReceiveMethod,
    refreshTime,
    exchangeBeginDateTime,
    exchangeEndDateTime,
    giftType,
    shelfId,
    mobile,
    giftTitle,
    memberCode,
    masterOrderNo,
  ]);

  // 发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  let { data: dataList, total } = queryOrderPage || {};

  const handUpLoad = () => {
    setBatchImportOpen(true);
  };
  //打开关闭批量导入dialog
  const onCloseBatchImportDialog = () => {
    setBatchImportOpen(false);
    setImportStatus('ready');
    setUploadSuccessData();
  };
  //批量导入的内容部分
  const batchImportContent = () => {
    return (
      <Loading loading={importFetchStatus}>
        <Box gap="16px 0" display="flex" flexDirection="column">
          <Box display="flex" alignItems="center">
            <Box
              sx={{
                width: '32px',
                height: '32px',
                fontSize: '16px',
                color: '#ffffff',
                background: theme.palette.primary.main,
                borderRadius: '50%',
                textAlign: 'center',
                lineHeight: '32px',
                marginRight: '10px',
              }}
            >
              1
            </Box>
            <Box sx={{ fontSize: '16px', color: '#212121' }}>
              根据标准模板格式填写信息，前往
              <span
                style={{
                  color: theme.palette.primary.main,
                  cursor: 'pointer',
                }}
                onClick={handleDownloadExcelTemplate}
              >
                下载模板{'>'}
                {'>'}
              </span>
            </Box>
          </Box>
          <Box display="flex" alignItems="center">
            <Box
              sx={{
                width: '32px',
                height: '32px',
                fontSize: '16px',
                color: '#ffffff',
                background: theme.palette.primary.main,
                borderRadius: '50%',
                textAlign: 'center',
                lineHeight: '32px',
                marginRight: '10px',
              }}
            >
              2
            </Box>
            <Box sx={{ fontSize: '16px', color: '#212121' }}>
              点击上传文件按钮，上传后系统将对文件内容进行检查
            </Box>
          </Box>
          {importStatus !== 'ready' && (
            <Box
              sx={{
                border:
                  importStatus === 'success'
                    ? '2px solid #4CAF50'
                    : importStatus === 'warning'
                    ? '2px solid #FF9800'
                    : '2px solid #FF3B30',
                borderRadius: '5px',
                padding: '12px 24px',
                marginBottom: importStatus === 'fail' ? '16px' : 0,
              }}
            >
              <Box
                sx={{
                  height: '22px',
                  lineHeight: '22px',
                  fontSize: '16px',
                  color:
                    importStatus === 'success'
                      ? '#4CAF50'
                      : importStatus === 'warning'
                      ? '#FF9800'
                      : '#FF3B30',
                }}
              >
                {importStatus === 'success' ? (
                  '文件上传成功'
                ) : importStatus === 'warning' ? (
                  <>
                    文件内容校验异常，点我
                    <span
                      style={{
                        color: theme.palette.primary.main,
                        cursor: 'pointer',
                      }}
                      onClick={handleDownloadExcelFailData}
                    >
                      下载文件{'>'}
                      {'>'}
                    </span>
                  </>
                ) : (
                  '文件上传失败'
                )}
              </Box>
              <Box
                sx={{
                  lineHeight: '22px',
                  fontSize: '16px',
                  color: '#212121',
                  marginTop: '8px',
                }}
              >
                {importStatus === 'success' ? (
                  '上传成功'
                ) : importStatus === 'warning' ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `共计上传${uploadSuccessData?.totalNum}条数据，成功${uploadSuccessData?.successNum}条，失败${uploadSuccessData?.failNum}条。<br />你可以下载未上传成功的数据`,
                    }}
                  />
                ) : (
                  '请下载模板，按照指定方式上传！'
                )}
              </Box>
            </Box>
          )}
        </Box>
      </Loading>
    );
  };
  console.log(importStatus, 'importStatus');
  //批量导入底部按钮自定义
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          gap: '0 32px',
          width: '100%',
          marginBottom: '16px',
        }}
      >
        {importStatus === 'ready' && (
          <Button
            sx={{ width: '100px!important' }}
            variant="contained"
            onClick={handleUploadExcel}
          >
            上传文件
          </Button>
        )}
        {(importStatus === 'success' || importStatus === 'warning') && (
          <Button
            sx={{ width: '100px!important' }}
            variant="contained"
            onClick={!importFetchStatus && onContinueBatchImport}
          >
            继续
          </Button>
        )}
        {(importStatus === 'success' || importStatus === 'warning') && (
          <Button
            sx={{
              width: '100px!important',
              color: theme.palette.primary.main,
            }}
            variant="outlined"
            onClick={onCloseBatchImportDialog}
          >
            取消
          </Button>
        )}
      </Box>
    );
    return { buttonNode, isShow: importStatus !== 'fail' };
  };

  //下载模板
  const handleDownloadExcelTemplate = () => {
    download('/activityPoints/importExpressTemplate');
  };

  //上传excel
  const handleUploadExcel = () => {
    inputUploadExcelRef.current.click();
  };
  //批量上传
  const handleFileChange = (e) => {
    setImportFetchStatus(1);
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    // 上传excel
    uploadExcel(file, formData, '/activityPoints/importExpress', (res) => {
      if (res?.code === 0) {
        if (res.data.failNum === 0) {
          setImportStatus('success');
        } else {
          setImportStatus('warning');
        }
        setUploadSuccessData(res.data);
      } else {
        setImportStatus('fail');
      }
      setImportFetchStatus();
      history.replace(
        `${pathname}?${qs.stringify({
          ...query,
          pageNum: 1,
          pageSize: pageSize,
          refreshTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        })}`,
      );
    });
    inputUploadExcelRef.current.value = '';
  };
  //点击批量导入的继续按钮
  const onContinueBatchImport = () => {
    setImportStatus('ready');
    setUploadSuccessData();
    inputUploadExcelRef.current.click();
  };
  //点击下载批量导入失败的数据
  const handleDownloadExcelFailData = () => {
    const { failFilePath } = uploadSuccessData;
    downLoadPrivateFile(failFilePath);
  };

  return (
    <IndexStyled>
      <div
        data-log={JSON.stringify({
          oid: 'page_point_mall_exchange_record_list',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
        className="mm_content"
      >
        <div className={classnames('search_group', 'single_component1')}>
          <SearchGroup
            searchRef={searchRef}
            query={query}
            handleSearch={(par) => handleSearch(par)}
            restClick={handleRestClick}
          />
        </div>
        <ActionBtnGroup handUpLoad={handUpLoad} />
        <div className={classnames('table_page', 'single_component')}>
          {/* 默认使用loading包裹，使用tabel的loading会闪屏，且加载时tabel列头也加载 */}
          <TablePage
            pagination={{
              pageNum,
              pageSize,
            }}
            loading={loading}
            total={total}
            tableData={dataList}
            setPageData={handlePageChange}
          />
        </div>
      </div>
      <DialogDataML
        open={batchImportOpen}
        title={
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <span style={{ fontSize: '18px', fontWeight: 600 }}>批量上传</span>
            <IconButton
              aria-label="close"
              onClick={() => onCloseBatchImportDialog()}
            >
              <CloseIcon className="coupon-dialog-close-icon-style" />
            </IconButton>
          </Box>
        }
        content={batchImportContent()}
        onClose={onCloseBatchImportDialog}
        button={initButton()}
      />
      <input
        className="input"
        type="file"
        ref={inputUploadExcelRef}
        hidden
        onChange={(event) => handleFileChange(event)}
        accept={
          ('application/vnd.ms-excel.xlsx',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        }
      />
    </IndexStyled>
  );
};

export default GoodsManagement;
